
import { AutomotiveSchedulerStep } from '../types/session';
import { computed, defineComponent, PropType } from 'vue';
import type { ISchedulerProgressStep } from '../types/ui';

export default defineComponent({
	props: {
		currentStep: {
			type: Number as PropType<AutomotiveSchedulerStep>,
			required: true,
		},
		steps: {
			type: Array as PropType<ISchedulerProgressStep[]>,
			required: true,
		},
	},
	setup(props) {
		const activeStep = computed(() => props.steps.find(({ step }) => step === props.currentStep));
		return {
			activeStep,
		};
	}
});
